import { useQuery } from "@tanstack/react-query";
import { EobControllerApi } from "../../../services";
import { getConfigObject, getXtenantId } from "../../../utils/utils";

export function useGetEobById(eobId?: string) {
  return useQuery({
    queryKey: ["get-eob-by-id", eobId],
    enabled: !!eobId,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const response = await new EobControllerApi(
        getConfigObject()
      ).getEobById(eobId!, getXtenantId());
      return response?.data;
    },
  });
}
